import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IAdmissionInitialState} from "../types";
import {IEntityWithIDTranslations} from "../../../../../../../types";
import {GetAdmission, GetDeleteAdmission} from "../store/thunk";

const initialState: IAdmissionInitialState = {
    admissionData: [],
    admissionRestoreData: [],
    isAdmissionRestore:false,
    selectedAdmissionIDs:[],
    isLoadingAdmission:true
}

const admissionBasisSlice = createSlice({
    name: "admissionBasis",
    initialState,
    reducers: {
        setAdmissionData: (state, action: PayloadAction<{data:IEntityWithIDTranslations[]}>) => {
            const {data} = action.payload;
            state.admissionData= data
        },
        deletedAdmission: (state, action: PayloadAction<number>) => {
            state.admissionData= state.admissionData.filter((elem) => elem.id !== action.payload);
        },
        updateAdmission: (state, action: PayloadAction<IEntityWithIDTranslations>) => {
            const updateData = action.payload;
            state.admissionData = state.admissionData.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        setAdmissionRestoreData:(state, action) => {
            state.admissionRestoreData = action.payload;
        },
        setIsAdmissionRestore:(state)=>{
            state.isAdmissionRestore =!state.isAdmissionRestore;
        },
        deletedRestoreAdmission:(state,action)=>{
            state.admissionRestoreData = state.admissionRestoreData.filter(
                (elem) => elem.id !== action.payload
            );
        },
        setSelectedAdmissionIDs: (state, action) => {
            state.selectedAdmissionIDs=action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAdmission.pending, (state) => {
                state.isLoadingAdmission = true;
            })
            .addCase(GetAdmission.fulfilled, (state) => {
                state.isLoadingAdmission = false;
            })
            .addCase(GetAdmission.rejected, (state) => {
                state.isLoadingAdmission = false;
            })
            .addCase(GetDeleteAdmission.pending, (state) => {
                state.isLoadingAdmission = true;
            })
            .addCase(GetDeleteAdmission.fulfilled, (state) => {
                state.isLoadingAdmission = false;
            })
            .addCase(GetDeleteAdmission.rejected, (state) => {
                state.isLoadingAdmission = false;
            });
    },
})

export const {
    setSelectedAdmissionIDs,
    deletedRestoreAdmission,
    setAdmissionRestoreData,
    setIsAdmissionRestore,
    deletedAdmission,
    updateAdmission,
    setAdmissionData
}=admissionBasisSlice.actions;

export default admissionBasisSlice